import axios from "./axios";

const pointsRefresh = () =>
  axios.get(`/users/refresh-points/`).then(
    (res) => res,
    (err) => err.response
  );

export { pointsRefresh };